import styled from 'styled-components'
import {
  LineWithSeparator,
  TdLink as TdLinkBase,
  TdTitle as TdTitleMain,
} from '../../_styles'
import { TdSub } from 'components/Common/Table/_styles'
import { FontMode } from '../_methods/types'

const fonts = {
  XS: {
    tradeName: 'var(--typography-11-16-normal)',
    productDetails1: 'var(--typography-12-16-semibold)',
    productDetails2: 'var(--typography-11-16-normal)',
    productDetails3: 'var(--typography-11-16-normal)',
  },
  S: {
    tradeName: 'var(--typography-12-16-normal)',
    productDetails1: 'var(--typography-12-16-semibold)',
    productDetails2: 'var(--typography-11-16-normal)',
    productDetails3: 'var(--typography-11-16-normal)',
  },
  M: {
    tradeName: 'var(--typography-12-16-normal)',
    productDetails1: 'var(--typography-14-20-semibold)',
    productDetails2: 'var(--typography-12-16-normal)',
    productDetails3: 'var(--typography-12-16-normal)',
  },
  L: {
    tradeName: 'var(--typography-14-20-normal)',
    productDetails1: 'var(--typography-16-24-semibold)',
    productDetails2: 'var(--typography-14-20-normal)',
    productDetails3: 'var(--typography-14-20-normal)',
  },
}
export const LastLine = styled(TdSub)<{ fontMode: FontMode }>`
  ${LineWithSeparator} {
    font: ${({ fontMode }) => fonts[fontMode].productDetails3};
    margin-top: ${({ fontMode }) =>
      fontMode !== 'S' && fontMode !== 'XS' ? '4px' : '0'};
  }
`
export const ProductDetailsWrapper = styled.div<{ fontMode: FontMode }>`
  ${LineWithSeparator} {
    font: ${({ fontMode }) => fonts[fontMode].productDetails2};
    margin-bottom: 0;
    margin-top: ${({ fontMode }) =>
      fontMode !== 'S' && fontMode !== 'XS' ? '4px' : '0'};
  }
`
export const TdLink = styled(TdLinkBase)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const TnWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
`
export const TdTradeName = styled(TdTitleMain)<{
  noLinks?: boolean
  fontMode: FontMode
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  font: ${({ fontMode }) => fonts[fontMode].tradeName};
  color: ${({ noLinks }) =>
    noLinks ? 'var(--color-sw-60)' : 'var(--color-velvet)'};

  svg {
    flex-shrink: 0;
  }
`
export const TdProduct = styled(TdTitleMain)<{
  noLinks?: boolean
  fontMode: FontMode
}>`
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${LineWithSeparator} {
    font: ${({ fontMode }) => fonts[fontMode].productDetails1};
    margin-bottom: 0;
  }

  div {
    color: ${({ noLinks }) =>
      noLinks ? 'var(--color-night)' : ' var(--color-velvet)'};
    font: var(--typography-12-16-semibold);
  }
`
export const ScoreWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const Highlight = styled.span`
  background: #cc740014;
  color: #cc7400;
`
export const Tn = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
